import { useState, type ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/widgets/sidebar'
import { CommandPalette, useCommandPalette } from '@/features/command-palette/ui/CommandPalette'
import { Topbar } from './Topbar'
import styles from './AppLayout.module.css'

/** Каркас кабинета: колонка навигации и область страницы. */
export function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(false)
  const palette = useCommandPalette()

  return (
    <div className={styles.layout}>
      <Sidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />

      {/* Затемнение перехватывает клик мимо меню и закрывает его. На
          телефоне это единственный привычный способ выйти. */}
      {menuOpen && <div className={styles.backdrop} onClick={() => setMenuOpen(false)} />}

      <div className={styles.main}>
        <Topbar onSearch={() => palette.setOpen(true)} onMenu={() => setMenuOpen(true)} />

        <main className={styles.scroll}>
          <div className={styles.content}>
            <Outlet />
          </div>
        </main>
      </div>

      <CommandPalette open={palette.open} onClose={() => palette.setOpen(false)} />
    </div>
  )
}

interface PageLayoutProps {
  children: ReactNode
  /** Колонка справа: карта настройки, сводка. Пусто — одна колонка. */
  aside?: ReactNode
}

/**
 * Страница с колонкой-компаньоном.
 *
 * Правая колонка держит то, что не действие, а обстановка: сколько
 * заполнено, что дальше, где сейчас агент. Внизу страницы это читалось
 * бы как приписка, а сбоку — как то, на что смотрят по ходу работы.
 */
export function PageLayout({ children, aside }: PageLayoutProps) {
  if (!aside) return <>{children}</>

  return (
    <div className={styles.split}>
      <div className={styles.splitMain}>{children}</div>
      <aside className={styles.aside}>{aside}</aside>
    </div>
  )
}

interface PageHeaderProps {
  title: string
  description?: string
  children?: ReactNode
}

/** Заголовок страницы: одинаковый на всех разделах. */
export function PageHeader({ title, description, children }: PageHeaderProps) {
  return (
    <header className={styles.pageHeader}>
      <h1 className={styles.title}>{title}</h1>
      {description && <p className={styles.description}>{description}</p>}
      {children}
    </header>
  )
}
